export default __webpack_public_path__ + "static/10-82ecb9b25800dc634b3183ca75bdbf27.png";